import logo from '../assets/images/logo/logo-1.svg';
import newsData from '../data/news.json';


function VideoPlayer({ provider, media, title }) {
  if (provider === "youtube") {
    return (
      <div className="video-wrap" style={{ position: "relative", paddingTop: "56.25%" }}>
        <iframe
          src={`https://www.youtube.com/embed/${media}`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: "none" }}
        />
      </div>
    );
  }
  // Other provider types (vimeo, mp4, cloudflare) can go here...
  return null;
}

export default function NewsSection() {
  return (
    <div className="rts-blog-list-area rts-section-gap">
      <div className="container">
        <div className="row g-5">
          <div className="col-xl-8 col-md-12 col-sm-12 col-12">
            {newsData.map((news) => (
              <div className="blog-single-post-listing" key={news.id}>
                <div>
                  {news.type === "image" ? (
                    <img src={news.media} alt={news.title} />
                  ) : (
                    <VideoPlayer
                      provider={news.provider}
                      media={news.media}
                      title={news.title}
                    />
                  )}
                </div>
                <div className="blog-listing-content">
                  <div className="user-info">
                    <div className="single">
                      <i className="far fa-user-circle" />
                      <span>by {news.author}</span>
                    </div>
                    <div className="single">
                      <i className="far fa-clock" />
                      <span>{news.date}</span>
                    </div>
                  </div>
                  <span className="blog-title">
                    <h3 className="title animated fadeIn">{news.title}</h3>
                  </span>
                  <p className="disc">{news.content}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="col-xl-4 col-md-12 col-sm-12 col-12 mt_lg--60">
            <div className="rts-single-wized contact">
              <div className="wized-header">
                <a href="/">
                  <img src={logo} alt="Business_logo" style={{ height: "100px" }} />
                </a>
              </div>
              <div className="wized-body">
                <h5 className="title">Need Help? We Are Here To Help You</h5>
                <a className="rts-btn btn-primary" href="contactus.html">
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
